import { FormEvent, FormEventHandler, useState } from "react";
import {
  registrationInfoStore,
  useRegistration,
} from "../../libs/registration/registration.hook";
import { AppForm } from "../form/styles/app-form";
import { Checkbox, CheckboxWrapper } from "../form/styles/checkbox";
import { SingleInput } from "../form/styles/single-input";
import { SmallButton } from "../form/styles/small-button";

export const StudentInfoComp = (props: {
  id: string;
  showSelection: boolean;
  showOptional?: boolean;
}) => {
  const student = registrationInfoStore.students?.[props.id] || {};

  const [isParticipating, setIsParticipating] = useState<boolean>(
    student.isParticipating === undefined ? true : student.isParticipating
  );
  const [firstName, setFirstName] = useState(student.firstName || "");
  const [lastName, setLastName] = useState(student.lastName || "");
  const [dateOfBirth, setDateOfBirth] = useState(student.dateOfBirth || "");
  const [medicalConditions, setMedicalConditions] = useState(
    student.medicalConditions || ""
  );
  const [medications, setMedications] = useState(student.medications || "");
  const { setRegistrationInfo } = useRegistration();

  const onBlur = () => {
    setRegistrationInfo({
      students: {
        ...registrationInfoStore.students,
        [props.id]: {
          firstName,
          lastName,
          dateOfBirth,
          medicalConditions,
          medications,
          isParticipating,
        },
      },
    });
  };

  const onRemove = (event: any) => {
    event.preventDefault();
    if (registrationInfoStore.students?.[props.id]) {
      delete registrationInfoStore.students[props.id];
      setRegistrationInfo({
        students: {
          ...registrationInfoStore.students,
        },
      });
    }
  };

  return (
    <>
      {props.showSelection && (
        <CheckboxWrapper>
          <Checkbox
            checked={isParticipating}
            onChange={() => setIsParticipating(!isParticipating)}
            onBlur={onBlur}
            type="checkbox"
          />{" "}
          Will be participating
          <SmallButton onClick={onRemove} className="stick-right">
            X
          </SmallButton>
        </CheckboxWrapper>
      )}
      <SingleInput
        onChange={(event: any) => setFirstName(event.target.value)}
        onBlur={onBlur}
        value={firstName}
        placeholder="First name"
      />
      <SingleInput
        onChange={(event: any) => setLastName(event.target.value)}
        onBlur={onBlur}
        value={lastName}
        placeholder="Last name"
      />
      <SingleInput
        onChange={(event: any) => setDateOfBirth(event.target.value)}
        onBlur={onBlur}
        value={dateOfBirth}
        placeholder="Date of birth"
        type="date"
      />
      {props.showOptional && (
        <>
          <SingleInput
            onChange={(event: any) => setMedicalConditions(event.target.value)}
            onBlur={onBlur}
            value={medicalConditions}
            placeholder="(Optional) Medical conditions or Allergies"
          />
          <SingleInput
            onChange={(event: any) => setMedications(event.target.value)}
            onBlur={onBlur}
            value={medications}
            placeholder="(Optional) Medications"
          />
        </>
      )}
    </>
  );
};
